import {
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  ApplicationService,
  LargeFamilyCardAppEntityLargeFamilyCardWrite
} from '../openapi';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LargeFamilyCardsCommonService {
  constructor(
    private applicationService: ApplicationService
  ) {
  }

  updateLargeFamilyCards(
    currentApp: ApplicationAppEntityApplicationRead,
    payload: ApplicationAppEntityApplicationWrite,
    largeFamilyCards: LargeFamilyCardAppEntityLargeFamilyCardWrite[]
  ): Observable<ApplicationAppEntityApplicationRead> {
    if (largeFamilyCards.length) {
      return this.applicationService.patchApplicationApplicationItem({
        id: currentApp?.uuid || '',
        application: {
          ...payload,
          largeFamilyCards
        }
      });
    } else {
      return this.applicationService.patchApplicationApplicationItem({
        id: currentApp?.uuid || '',
        application: payload
      });
    }
  }
}
